import { post } from "../../helpers/utils/http-client";
import { APPS_ENDPOINT } from '../../consts/api-endpoints';

export async function analyticsQuery(appId, request) {
    try {
        return await post(`${APPS_ENDPOINT}/${appId}/analytics/query`, request);
    } catch (err) {
        console.debug('analyticsQuery failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

// `env`: 'test' (the draft app) or 'live' (the published app); each has its
// own reports.
export async function getAnalyticsReport(appId, range = 'last30', env = 'test') {
    // A precomputed report for one range: one point read, so no polling is
    // needed. `range` is 'last30' or { from: 'YYYY-MM', to: 'YYYY-MM' }. Only
    // 'last30' computes itself on first view; other ranges come back with
    // `report: null` until analysed.
    return await analyticsQuery(appId, { queryType: 'report', range, env });
}

export async function forceSync(appId, range = 'last30', env = 'test') {
    // Fire-and-forget: the analysis runs in the background and is refused
    // while one is already in flight for this app.
    return await analyticsQuery(appId, { queryType: 'forceSync', range, env });
}

export async function getSyncStatus(appId, env = 'test') {
    // The run's state lives in the backend, not in this tab, so a reloaded
    // page (or a second browser) can follow a run it did not start.
    return await analyticsQuery(appId, { queryType: 'syncStatus', env });
}
